import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { TicketInputTicketFragment } from './GetAllTicketNumbers';

const CreateTicketNumberMutation = gql`
  mutation CreateTicket($input: TicketNumberCreateInput!) {
    ticket_number_create(input: $input) {
      ...TicketInputTicket
    }
  }
  ${TicketInputTicketFragment}
`;


export const createTicketNumberGQL = graphql(CreateTicketNumberMutation, { name: 'createTicket' });
